import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";
import swal from "sweetalert";
import { API_URL } from "../constant";
import Loader from './loading';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $, { readyException } from 'jquery';


function AllMemberList() {

  const navigat = useNavigate();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  $('#example').DataTable().destroy();

  $(document).ready(function () {

    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort']
      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
      responsive: true
    });
    var dt = $('#example').DataTable();
    dt.columns([4, 12]).visible(false);
  });
  /*********************get parameter from url*********************************** */
  const params = useParams();

  /******************************************************** */

  useEffect(() => {
    document.title = "All member list";
    getAllPatientData();
  }, [1]
  );
  /************Get all patient user********************** */
  let getAllPatientData = async () => {
    const datas = { 'mob': params.mob };
   
    const res = await axios.post(API_URL + 'admin/allPatientMemberData', datas)
      .then(ress => {
       
        setUserData(ress.data.Rdata);
        setIsLoading(false);
      });
   
  }

  /***************** on click of mobile no************************************* */

  let getTestResult = (typ, pid, mob, name) => {
    return navigat('/patient_all_test_list/' + typ + '/' + pid + '/' + mob + '/' + name);
  }
  /***************** Anm details************************************ */

  const getAnmDetails = (anm_id, patient_mob) => {
    return navigat('/anm_mediacal_team_user/' + anm_id + '/' + patient_mob);
  }

  /*****************Back************************ */
  let backto = () => {
    if (params.typ == 'rp') {
      return navigat('/allPatient_csv');
    }
    if (params.typ == 'vb') {
      return navigat('/all_patient');
    }
     if (params.typ == 'fp') {
      return navigat('/follow-up-list');
    }

  }
  /******************Redirecting to edit page***************************** */
  let editUser = (data) => {
    
    return navigat('/edit_patient/' + data);
  }
  /************************************************ */


  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
        {isLoading ? (<Loader />) : (
          <>
          <div className="content-wrapper">
            <div className="row">


              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">All member list of  {params.mob}</h4> <button type="button" className="btn btn-outline-primary" onClick={backto} >Back</button>
                    
                   
                      <div className="table-responsive pt-3">
                        
                        <table className="table table-bordered display  nowrap" id="example">
                          <thead>
                            <tr>
                             
                              <th className="nosort"> </th>
                              <th className="nosort"> Action </th>
                              <th>Beneficiary Type</th>
                              <th> Name </th>
                              <th>Patient ID</th>
                              <th>Gender</th>
                              <th>Age</th>
                              <th>Pregnancy Duration</th>
                              <th>Aadhar no.</th>
                              <th> Guardian Name </th>
                              <th> Mobile No</th>
                              <th> Address</th>
                              <th> Anm/Medical Team member Id</th>
                              <th> RCH Id</th>
                             
                              <th> District </th>
                              <th> Block </th>
                              <th> Chc/Phc </th>
                              <th> Village </th>
                              <th> School </th>
                              <th> Added On </th>
                              

                            </tr>
                          </thead>
                          <tbody>

                            {userData.map((udata, index) => (
                              <tr key={index}>
                                <td></td>
                                <td>
                                  <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="View" onClick={() => getTestResult(params.typ, udata.patient_id, params.mob, udata.name)} >
                                    <i className="typcn typcn-eye  text-primary"></i>
                                  </button>
                                  <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Edit User" onClick={() => { editUser(udata.patient_id) }}>
                                    <i className="typcn typcn-edit  text-primary"></i>
                                  </button>
                                </td>
                               
                                <td> {udata.beneficiary_type}</td>
                                <td> <Link to={'/patient_all_test_list/' + params.typ + '/' + udata.patient_id + '/' + params.mob + '/' + udata.name} >{udata.name}</Link></td>
                                <td> {udata.patient_id}</td>

                                <td> {udata.gender != null ? udata.gender.toUpperCase() : ""}</td>
                                <td> {udata.age}</td>
                                <td> {udata.preg_duration}</td>
                                <td> {udata.aadhar_no}</td>
                                <td> {udata.guardian_name}</td>
                                <td> {udata.mobile_no}</td>
                                <td> {udata.address}</td>
                               
                                <td> <Link to={'/anm_mediacal_team_user/' + params.typ + '/' + udata.amn_teacher_u_id + '/' + params.mob} >{udata.amn_teacher_u_id}</Link></td>
                                <td> {udata.rch_uid}</td>
                              
                                <td> {udata.district_name} </td>
                                <td> {udata.block_name}</td>
                                <td> {udata.chc_name} </td>
                                <td> {udata.village_name} </td>
                                <td> {udata.school_name} </td>
                                <td><Moment format="DD-MM-YYYY" >{udata.added_on}</Moment></td>
                               
                              </tr>
                            )
                            )}

                          </tbody>
                        </table>
                      </div>
                    
                  </div>
                </div>
              </div>


            </div>
          </div>

          <Footer />
          </>
          )}
        </div>

      </div>

    </div>);
}

export default AllMemberList;